// extracted by mini-css-extract-plugin
export default {"placeholder":"video-link-module__placeholder--jzsth"};